module.exports = __webpack_public_path__ + "static/media/display_white.6c11d542.png";